<template>
  <div class="container">
    <div class="content">
      <div class="wrap">
        <div class="top">
          <div class="header">
            <!-- <img alt="logo" class="logo" src="static/img/vue-antd-logo.png" /> -->
            <img src="~@/assets/logo.png" class="logotitle" />
            <!-- <span class="title">{{systemName}}</span> -->
          </div>
          <!-- <div class="desc">Ant Design 是西湖区最具影响力的 Web 设计规范</div> -->
        </div>
        <div class="login">
          <a-form @submit="onSubmit" :autoFormCreate="(form) => this.form = form">
            <a-tabs size="large" :tabBarStyle="{textAlign: 'center'}" style="padding: 0 2px;">
              <a-tab-pane key="1">
                <!-- <a-alert type="error" :closable="true" v-show="error" :message="error" showIcon style="margin-bottom: 24px;" /> -->
                <a-form-item fieldDecoratorId="name" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入账户名', whitespace: true}]}">
                  <a-input size="large" placeholder="admin">
                    <a-icon slot="prefix" type="user" />
                  </a-input>
                </a-form-item>
                <a-form-item fieldDecoratorId="password" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入密码', whitespace: true}]}">
                  <a-input size="large" placeholder="请输入密码" type="password">
                    <a-icon slot="prefix" type="lock" />
                  </a-input>
                </a-form-item>
                <a-form-item :fieldDecoratorOptions="{rules: [{ required: true, message: '请验证码', whitespace: true}]}">
                  <div class="yzcode" @click="getCaptcha"><img :src="captcha"></div>
                  <a-input size="large" v-model="vcode" placeholder="验证码" style="width: 50%;float: right;height:44px">
                  </a-input>
                </a-form-item>
              </a-tab-pane>
              <!-- <a-tab-pane tab="手机号登录" key="2">
                <a-form-item>
                  <a-input size="large" placeholder="mobile number" >
                    <a-icon slot="prefix" type="mobile" />
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-row :gutter="8" style="margin: 0 -4px">
                    <a-col :span="16">
                      <a-input size="large" placeholder="captcha">
                      <a-icon slot="prefix" type="mail" />
                    </a-input>
                    </a-col>
                    <a-col :span="8" style="padding-left: 4px">
                      <a-button style="width: 100%" class="captcha-button" size="large">获取验证码</a-button>
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-tab-pane> -->
            </a-tabs>
            <div>
              <a-checkbox :checked="true">自动登录</a-checkbox>
              <!-- <a style="float: right">忘记密码</a> -->
            </div>
            <a-form-item>
              <!--//:loading="logging"-->
              <a-button style="width: 100%;margin-top: 24px" size="large" htmlType="submit" type="primary">登录</a-button>
            </a-form-item>
            <!-- <div>
              其他登录方式
              <a-icon class="icon" type="alipay-circle" />
              <a-icon class="icon" type="taobao-circle" />
              <a-icon class="icon" type="weibo-circle" />
              <router-link style="float: right" to="/dashboard/workplace" >注册账户</router-link>
            </div> -->
          </a-form>
        </div>
      </div>
    </div>
    <global-footer :link-list="linkList" :copyright="copyright" />
  </div>
</template>

<script>
import GlobalFooter from '../../layouts/GlobalFooter'
import { queryCaptcha, newLogin } from '../../service/login/loginService'
import storage from '../../utils/storage'
import lazyChannel from '../../router/lazyChannel'
import lazyDistributor from '../../router/lazyDistributor'

export default {
  name: 'Login',
  components: { GlobalFooter },
  data() {
    return {
      logging: false,
      captcha: '',
      uuid: '',
      error: '',
      vcode: '',
    }
  },
  computed: {
    systemName() {
      return this.$store.state.setting.systemName
    },
    linkList() {
      return this.$store.state.setting.footerLinks
    },
    copyright() {
      return this.$store.state.setting.copyright
    }
  },
  created() {
    this.getCaptcha()
  },
  methods: {
    getCaptcha() {
      queryCaptcha().then(data => {
        const map = new Map(Object.entries(data))
        this.captcha = map.get(data.uuid)
        this.uuid = data.uuid
        const publicKeyMap = JSON.parse(map.get('publicKeyMap'));
        sessionStorage.setItem('exponent', publicKeyMap.exponent);
        sessionStorage.setItem('modulus', publicKeyMap.modulus);
      })
    },
    onSubmit(e) {
      e.preventDefault()
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          this.logging = true
          let username = this.form.getFieldValue('name')
          let password = this.form.getFieldValue('password')
          const publicKey = this.$RSAUtils.getKeyPair(sessionStorage.getItem('exponent'), '', sessionStorage.getItem('modulus'));
          username = this.$RSAUtils.encryptedString(publicKey, username);
          password = this.$RSAUtils.encryptedString(publicKey, password);
          let parms = { username, password, type: 'CHANNEL', vcodeKey: this.uuid, vcode: this.vcode }
          newLogin(parms).then(result => {
            that.logging = false
            if (result.status == 200) {
              let res = result.data
              const user = res.user
              const token = res.token
              storage.set('user', user)
              storage.set('token', token)
              that.$cookies.set('token', token)
              const distributorRouter = lazyDistributor.distributorRouter
              const channelRouter = lazyChannel.channelRouter
              let old = that.$router.options.routes.filter((item, index, arr) => {
                return index < 2
              })
              if (user.proxyModelId == '31') {
                that.$router.addRoutes(channelRouter)
                that.$router.options.routes = [...old, ...channelRouter]
              } else if (user.proxyModelId == '32') {
                that.$router.addRoutes(distributorRouter)
                that.$router.options.routes = [...old, ...distributorRouter]
              }
              that.$router.push('/dashboard/Analysis')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  width: 400px;
  margin: 0 auto;
  border: 1px solid #d9d9d9;
  background: #fff;
  border-radius: 4px;
  -moz-box-shadow: 2px 2px 5px #d9d9d9, 2px 2px 5px #d9d9d9;
  -webkit-box-shadow: 2px 2px 5px #d9d9d9, 2px 2px 5px #d9d9d9;
  box-shadow: 2px 2px 5px #d9d9d9, 2px 2px 5px #d9d9d9;
  padding-top: 24px;
}
.logotitle {
  width: 60%;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  background: #f0f2f5 url('../../assets/TVYTbAXWheQpRcWDaDMu.svg') no-repeat center 110px;
  background-size: 100%;
  .content {
    padding: 32px 0;
    flex: 1;
    @media (min-width: 768px) {
      padding: 112px 0 24px;
    }
    .top {
      text-align: center;
      .header {
        height: 44px;
        line-height: 44px;
        a {
          text-decoration: none;
        }
        .logo {
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
        }
        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, 0.85);
          font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }
    .login {
      width: 368px;
      margin: 0 auto;
      /deep/.ant-tabs-ink-bar {
        background: none !important;
        height: 0;
      }
      .yzcode {
        width: 40%;
        height: 44px;
        display: inline-block;
        overflow: hidden;
        vertical-align: bottom;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: #fff;
        img {
          width: 100%;
          cursor: pointer;
        }
      }
      @media screen and (max-width: 576px) {
        width: 95%;
      }
      @media screen and (max-width: 320px) {
        .captcha-button {
          font-size: 14px;
        }
      }
      .icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue